import { useState, useCallback } from "react";
import { debounce } from "lodash";
import { Searcher } from "../store/core";
import { useHandleForm } from "./useHandleForm";

interface IUseSearch {
  search: Searcher;
  onFindAction: () => void;
  delay?: number;
  searchForm?: any;
  searchKey?: string;
}

export const useSearch = ({
  search,
  onFindAction = () => {},
  delay = 3000,
  searchForm,
  searchKey = "text",
}: IUseSearch) => {
  const form =
    searchForm ??
    useHandleForm(null, { [searchKey]: "" }, { [searchKey]: false });

  const debouncedQuery = useCallback(
    debounce((query) => search.setText(query), delay),
    [search],
  );

  const onFindClick = () => {
    search.setText(form.watchAllField[searchKey]);
    onFindAction();
  };

  const handleOnChange = (event) => {
    form.setValue(searchKey, event.target.value);

    if (event.target.value) {
      debouncedQuery(event.target.value);
    }
  };

  const handleOnClear = () => {
    search.setText("");
    form.setValue(searchKey, "");
  };
  return {
    form,
    onFindClick,
    handleOnChange,
    handleOnClear,
  };
};
